import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class TextImg {
  constructor(el) {
    this.el = el
    this.img = document.querySelector('.text-img--img')
    this.init()
  }

  init() {
    this.imgAnimation()
  }

  imgAnimation() {
    const isMobile = window.matchMedia('(max-width: 991px)').matches
    const yVal = isMobile ? 15 : 70

    gsap.set(this.img, { y: yVal })

    gsap.to(this.img, {
      y: -yVal,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: this.img,
        scrub: 1,
      },
    })
  }

}
